module.exports = __webpack_public_path__ + "img/mastercard_white.7f10d5e9.svg";